import React from 'react';
import { Scale } from 'lucide-react';
export function ModernSlaveryStatementPage() {
  return <div className="bg-white pt-20" data-id="element-741" data-mp="1mlu738d0ir5f">
      <section className="bg-navy-900 py-20 text-white" data-id="element-742" data-mp="1mksyrbndsire">
        <div className="max-w-4xl mx-auto px-6 lg:px-12" data-id="element-743" data-mp="1rckfkugqja4c">
          <div className="flex items-center gap-3 mb-6" data-id="element-744" data-mp="1rf6vpihoyxy6">
            <Scale className="h-5 w-5 text-gold-500" data-id="element-745" data-mp="1wb5e8pgc9lqo" />
            <span className="text-gold-500 font-semibold tracking-[0.24em] uppercase text-xs" data-id="element-746" data-mp="1we03cuaaruqf">Ethical Practice</span>
          </div>
          <h1 className="text-4xl md:text-6xl font-serif font-bold" data-id="element-747" data-mp="13mq34e0bvnkm">Modern Slavery Statement</h1>
          <p className="mt-5 text-gray-300" data-id="element-748" data-mp="18mcs1kpiqs99">Effective July 24, 2026</p>
        </div>
      </section>

      <main className="max-w-4xl mx-auto px-6 lg:px-12 py-16 space-y-10 text-gray-700 leading-relaxed" data-id="element-749" data-mp="1cog5ufznu8xp">
        <StatementSection title="Our commitment" data-id="element-750" data-mp="2k2j6ywiejjc6">
          <p data-id="element-751" data-mp="2k3uf18ivrd93">TalentBridge Global is committed to conducting business responsibly and to opposing all forms of modern slavery, forced labor, human trafficking, child labor, and exploitative recruitment practices.</p>
        </StatementSection>
        <StatementSection title="Responsible recruitment" data-id="element-752" data-mp="w4drov0kd2ym">
          <p data-id="element-753" data-mp="w2ubt5itktxd">We believe candidates should never be charged fees for access to legitimate opportunities. We expect professional conduct, informed consent, and respect for candidate dignity throughout our recruitment and advisory work.</p>
        </StatementSection>
        <StatementSection title="Due diligence" data-id="element-754" data-mp="i5nu7e9u119q">
          <p data-id="element-755" data-mp="de5usungj8qv">We seek to work with clients, partners, and service providers whose conduct is consistent with applicable law and our ethical expectations. Where concerns arise, we assess the situation and take appropriate action.</p>
        </StatementSection>
        <StatementSection title="Reporting concerns" data-id="element-756" data-mp="3hkps9bftxn1">
          <p data-id="element-757" data-mp="3vkae2spqknd8">Anyone who suspects exploitative recruitment activity connected to TalentBridge may contact us at <a className="text-gold-600 font-semibold hover:text-navy-900" href="mailto:contact@talentbridge.blog?subject=Ethical%20recruitment%20concern" data-id="element-758" data-mp="3qk5wt0h07oly">contact@talentbridge.blog</a>. Reports will be reviewed sensitively and in good faith.</p>
        </StatementSection>
        <StatementSection title="Review" data-id="element-759" data-mp="3kwc5gg9cwvli">
          <p data-id="element-760" data-mp="36zpa2hx1ydhp">We review this statement periodically as our operations, partnerships, and legal obligations evolve.</p>
        </StatementSection>
      </main>
    </div>;
}
type StatementSectionProps = {
  title: string;
  children: React.ReactNode;
};
function StatementSection({
  title,
  children
}: StatementSectionProps) {
  return <section data-id="element-761" data-mp="8gqko0wo004w">
      <h2 className="text-2xl font-serif font-bold text-navy-900 mb-3" data-id="element-762" data-mp="8jct02rdqjo6">{title}</h2>
      {children}
    </section>;
}